"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _QuestionnaireBody = _interopRequireDefault(require("./QuestionnaireBody"));
var _QuestionTitle = _interopRequireDefault(require("./QuestionTitle"));
var _QuestionFooter = require("./QuestionFooter");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _DynamicStepper = _interopRequireDefault(require("../DynamicStepper/DynamicStepper"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalStepper = _interopRequireDefault(require("../VerticalStepper"));
var _useCurrentQuestion = require("../../hooks/questionnaire/useCurrentQuestion");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ModalWrapper = _styledComponents.default.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`;
const ImageWrapper = _styledComponents.default.div`
  display: block;
  width: max-content;
  position: relative;
  align-self: center;
  bottom: 0;
  flex-shrink: 0
  z-index: 1;
`;
const StyledBackground = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  background-color: rgb(71 0 0 / 50%) !important;
`;
const StyledQuestionnaireWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  margin-bottom: 10px;
  height: 100%;

  z-index: 2;
  position: relative;
`;
const StyledQuestionnaireBackground = _styledComponents.default.div`
  background-color: rgb(71 0 0 / 50%) !important;
  padding: 15px;
`;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  flex-direction: column-reverse;
`;
const StyledStepper = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  flex-shrink: 0
  position: absolute;
  width: 50%;
  margin: 5px;
`;
const StyledStepperMobile = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  background-color: rgb(71 0 0 / 50%) !important;
  padding-top: 20px;
  margin-top: -100px;
`;
const StyledImage = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  display: block;
  width: max-content;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`;
const GermanyQuestionnaireBody = () => {
  const {
    icons
  } = (0, _useCurrentQuestion.useCurrentQuestion)();
  return /*#__PURE__*/_react.default.createElement(ModalWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'between'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(ModalWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5,
      right: 5
    }
  }, /*#__PURE__*/_react.default.createElement(StyledStepper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 3
  }, "title"), /*#__PURE__*/_react.default.createElement(_VerticalStepper.default, null))), /*#__PURE__*/_react.default.createElement(StyledImage, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: {
      xl: icons.large
    },
    iconWidth: "390px",
    iconHeight: "226px"
  }))), /*#__PURE__*/_react.default.createElement(StyledQuestionnaireWrapper, {
    col: 8
  }, /*#__PURE__*/_react.default.createElement(StyledQuestionnaireBackground, null, /*#__PURE__*/_react.default.createElement(_QuestionTitle.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null)), /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(StyledStepperMobile, null, /*#__PURE__*/_react.default.createElement(_DynamicStepper.default, null)), /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: {
      sm: icons.small
    },
    iconWidth: "296px",
    iconHeight: "296px"
  }))), /*#__PURE__*/_react.default.createElement(StyledBackground, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_QuestionTitle.default, null), /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null), /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null)))))));
};
var _default = GermanyQuestionnaireBody;
exports.default = _default;